const loaderBackgroundColor = '#ece7ec'
const loaderColor = '#3D2562'

export {
  loaderBackgroundColor,
  loaderColor,
}
